var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSessionOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 236,
    viewBox: "0 -10 301 236",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M249.217 86.3597L255.566 93.9286V85.4473L249.217 86.3597Z",
    fill: "#D5D1E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M246.995 28.8971C243.876 27.5583 240.444 26.8179 236.839 26.8179C222.591 26.8179 211.036 38.3731 211.036 52.6209C211.036 61.4762 221.963 57.7516 228.769 62.3962C232.912 65.2233 236.839 78.424 236.839 78.424C241.266 78.424 245.432 77.3096 249.067 75.3426C249.067 75.3426 248.656 61.4837 248.573 57.8114L255.566 59.0455V40.5122C251.528 37.7374 248.469 33.6538 246.995 28.8896V28.8971Z",
    fill: "#F9F8F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4741 153.978C39.6285 151.293 35.3355 141.286 27.258 137.427C12.5091 130.389 -3.57104 142.737 0.699552 159.146C5.00754 175.705 24.1168 179.766 22.4115 193.767C21.7608 199.1 21.5738 204.335 22.6733 209.443H58.5807L47.4816 153.971L47.4741 153.978Z",
    fill: "#D5D1E1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.145 137.599C103.246 130.755 99.4243 131.99 89.9408 131.444C78.1985 130.77 75.9921 122.656 73.0005 115.543C71.1531 111.145 64.0779 101.265 50.6004 103.778C43.4803 105.289 37.684 111.018 36.0311 120.606C33.1292 137.464 52.2234 147.277 46.4196 160.134C39.1274 176.289 38.4244 193.879 58.5732 209.459H98.2501C98.2501 209.459 93.7701 187.455 89.1854 166.304C93.3139 162.407 112.52 143.717 108.138 137.599H108.145Z",
    fill: "#F7F6F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7828 196.101L53.2181 120.15",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2305 139.087L70.7491 153.806",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M82.7907 176.924L54.8187 178.45",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7452 179.206L17.595 152.236",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4604 171.861L22.4265 171.464",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1041 160.62L25.7622 150.179",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.9026 199.93L35.4177 201.613",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M225.792 123.202C224.438 125.393 224.82 130.995 231.162 130.995L225.792 123.202Z",
    fill: "#9A8FB7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M236.472 117.458C238.005 117.487 239.224 117.981 239.853 118.692C241.274 120.307 241.154 123.299 240.122 125.071L236.472 117.458Z",
    fill: "#9A8FB7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M119.625 194.717L135.369 109.403C107.277 114.586 85.3335 138.444 83.7704 168.226C82.9551 183.716 87.7941 198.203 96.4774 209.668L197.685 209.145C203.257 201.636 207.199 192.825 208.994 183.207L202.891 170.358L119.625 194.717Z",
    fill: "#FBF7CE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M161.987 120.023L143.2 167.897L145.227 167.015L144.471 169.438L202.906 142.274C194.133 125.52 178.03 113.09 158.629 109.448C164.508 116.022 161.995 120.016 161.995 120.016L161.987 120.023Z",
    fill: "#FBF7CE"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.364 209.706C185.375 225.494 166.168 235.411 144.853 234.693C125.048 234.02 107.681 224.312 96.5896 209.661",
    stroke: "#DA4A8E",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M146.468 100.278C146.468 100.278 151.793 103.008 156.917 107.698C162.937 113.202 163.782 117.361 162.294 118.789C160.806 120.21 153.79 119.081 144.935 110.996L146.476 100.286L146.468 100.278Z",
    fill: "#9A8FB7"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M185.973 73.5999C184.141 85.3571 184.058 125.236 202.263 127.031C211.454 127.936 221.738 117.607 223.436 91.7817C223.436 91.7817 227.983 96.9648 232.501 91.7817C238.409 84.9907 237.198 69.8678 230.519 70.4288C225.74 70.8326 224.191 76.988 224.191 76.988",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M223.436 91.7817L240.115 125.079",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 130.92L218.956 113.277",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M188.875 86.3597C189.68 86.3597 190.333 85.7068 190.333 84.9013C190.333 84.0958 189.68 83.4429 188.875 83.4429C188.069 83.4429 187.417 84.0958 187.417 84.9013C187.417 85.7068 188.069 86.3597 188.875 86.3597Z",
    fill: "#0E090C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M205.232 85.4471C206.037 85.4471 206.69 84.7942 206.69 83.9887C206.69 83.1832 206.037 82.5303 205.232 82.5303C204.426 82.5303 203.773 83.1832 203.773 83.9887C203.773 84.7942 204.426 85.4471 205.232 85.4471Z",
    fill: "#0E090C"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M242.635 74.6174C245.799 69.4568 246.397 64.6926 242.328 60.8782C238.821 57.5874 238.768 54.8276 239.479 48.0141C240.189 41.2006 235.515 36.728 228.193 37.0347C222.912 37.2516 222.703 31.6422 217.924 30.8345C213.145 30.0192 210.908 33.1754 208.365 33.684C202.808 34.7984 200.228 30.4306 194.843 33.684C189.451 36.9374 190.976 41.3127 189.256 43.0404C187.536 44.7681 183.25 44.6709 183.108 51.275C183.063 53.3093 183.744 54.85 184.829 56.0093L195.404 50.8487C196.608 54.0273 193.34 56.9516 190.445 58.8289C190.67 58.8813 190.902 58.9261 191.126 58.9635L205.778 52.6287C207.094 56.7347 206.937 59.9807 205.688 62.5909C210.205 64.9319 213.765 61.3419 216.002 64.2887C218.238 67.2355 222.411 63.982 223.017 67.1382C223.63 70.287 220.369 70.287 219.981 74.0564C219.592 77.8185 221.387 77.9232 221.387 80.9223C221.387 83.9214 218.537 84.9087 218.537 84.9087L221.686 87.2721C224.274 83.9962 223.937 81.8796 224.446 77.7063C224.954 73.5404 228.028 69.8532 231.461 70.4665C234.729 71.0498 238.566 75.7841 235.051 86.3596C233.002 92.5299 229.853 94.5568 226.076 93.5396C224.483 93.1133 223.436 91.7895 223.436 91.7895L228.245 101.385C231.543 101.669 233.69 100.084 234.707 95.4094C235.724 90.7349 238.065 91.1388 240.122 89.3962C246.457 84.0261 238.776 80.9298 242.642 74.6323L242.635 74.6174Z",
    fill: "#0E090C",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M184.821 56.002L141.577 77.1006L137.53 100.017C137.53 100.017 140.26 106.411 144.927 110.996L148.839 83.8094C148.839 83.8094 151.075 89.9573 159.639 87.908C168.202 85.8587 175.285 85.4847 175.285 96.4716C175.285 96.4716 180.872 97.4065 180.685 90.6977C180.498 83.9889 176.033 80.8252 173.423 79.3369C173.423 79.3369 182.921 78.589 183.108 74.6849C183.108 74.6849 186.459 73.3835 195.03 70.3993C200.034 68.6567 203.93 66.2559 205.68 62.5911",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M191.119 58.9561L186.564 60.9231C186.564 60.9231 188.411 60.1303 190.438 58.814",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M159.669 83.51C159.669 83.51 166.557 81.1541 168.913 74.5276C168.913 74.5276 179.72 74.4378 178.068 65.7246L182.263 73.1813",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M178.068 65.7245C178.068 65.7245 182.697 63.032 186.564 60.9229C190.431 58.8212 194.567 56.9589 195.599 52.8379",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M179.967 69.135C179.967 69.135 193.325 63.7202 197.506 61.8878C201.687 60.0554 206.967 58.2529 205.77 52.6211",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M181.762 72.2914C181.762 72.2914 193.931 67.5571 198.553 65.7322C203.175 63.8998 207.034 61.5064 207.034 56.9292",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M173.423 79.329C173.423 79.329 182.293 78.9401 183.108 74.6769C183.108 74.6769 188.239 72.8745 192.958 71.1169C197.678 69.3593 202.666 67.654 205.09 63.6602",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M195.599 77.7061L193.527 104.19H200.116",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M202.898 82.7771C202.898 82.7771 204.237 80.9148 207.281 81.386C210.138 81.8272 211.881 84.602 211.881 84.602",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M186.594 83.9887C186.594 83.9887 187.147 82.4629 189.249 82.3358C191.68 82.1862 193.25 84.602 193.25 84.602",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M198.919 110.113C200.58 108.692 203.781 109.47 203.781 112.566C203.781 115.132 200.894 116.089 199.211 114.787",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M223.047 132.91L144.464 169.438",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M255.566 117.794L247.638 121.482",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M162.586 118.498C160.185 121.414 150.926 117.121 144.935 110.988C138.944 104.856 137.254 99.2163 137.254 99.2163L119.633 194.718L202.898 170.358L221.461 209.451",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M142.392 176.064L145.219 167.015L136.274 170.911",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M143.2 167.897L162.586 118.498",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M236.083 129.499C240.997 134.316 240.541 141.339 240.114 146.013C239.598 151.697 241.229 157.015 249.187 160.291C257.144 163.567 259.605 168.42 259.717 176.057C259.874 186.423 260.884 193.999 273.06 198.913",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M246.292 154.031C247.581 154.031 248.626 152.986 248.626 151.697C248.626 150.409 247.581 149.364 246.292 149.364C245.003 149.364 243.959 150.409 243.959 151.697C243.959 152.986 245.003 154.031 246.292 154.031Z",
    fill: "#9A8FB7"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M267.533 191.098C268.822 191.098 269.867 190.053 269.867 188.764C269.867 187.475 268.822 186.431 267.533 186.431C266.244 186.431 265.2 187.475 265.2 188.764C265.2 190.053 266.244 191.098 267.533 191.098Z",
    fill: "#9A8FB7"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M148.839 83.8018L144.927 110.988",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M255.566 85.4473V209.451H57.8776",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M255.566 40.5195V58.821",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M164.306 91.7821C140.746 95.6937 106.649 88.0051 99.2821 56.6077C95.9614 42.4571 100.763 28.2393 110.83 28.2393C123.163 28.2393 128.099 43.9829 125.22 58.3802C122.654 71.2219 113.799 86.1802 90.8606 86.4869C80.8984 86.6215 73.1874 83.3157 67.3985 78.6337",
    stroke: "#DA4A8E",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M267.533 44.0051C279.409 44.0051 289.036 34.3781 289.036 22.5025C289.036 10.627 279.409 1 267.533 1C255.658 1 246.031 10.627 246.031 22.5025C246.031 34.3781 255.658 44.0051 267.533 44.0051Z",
    stroke: "#DA4A8E",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M289.036 47.4528C295.091 47.4528 300 42.5438 300 36.4884C300 30.4329 295.091 25.5239 289.036 25.5239C282.98 25.5239 278.071 30.4329 278.071 36.4884C278.071 42.5438 282.98 47.4528 289.036 47.4528Z",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M252.395 85.9182C258.401 84.8187 272.664 80.9221 270.375 69.5313C269.193 63.6602 263.681 59.442 248.573 57.8115L249.224 86.3519L255.574 93.6815",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M249.067 71.229H270.241",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M249.067 79.0447L269.336 76.8159",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M248.798 64.0415L268.064 65.111",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M230.9 130.92C233.174 130.846 237.736 130.03 240.122 125.079C241.049 123.157 241.55 120.248 240.122 118.498L247.639 121.482C248.626 123.471 248.783 126.164 248.581 128.355C248.155 132.917 246.367 134.877 246.367 134.877L236.308 129.507L234.176 140.299C234.176 140.299 225.71 139.948 223.055 132.917L224.326 127.45C224.82 125.169 225.164 123.935 225.448 123.396",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M96.328 209.451C91.1001 202.129 83.3068 190.469 83.7705 168.219C84.2193 146.641 98.9607 127.45 110.12 120.143",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5323 86.98C63.3879 86.98 71.3775 78.9904 71.3775 69.1348C71.3775 59.2791 63.3879 51.2896 53.5323 51.2896C43.6766 51.2896 35.687 59.2791 35.687 69.1348C35.687 78.9904 43.6766 86.98 53.5323 86.98Z",
    fill: "#FBF7CE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8376 58.4171C72.8931 58.4171 77.8021 53.5082 77.8021 47.4527C77.8021 41.3972 72.8931 36.4883 66.8376 36.4883C60.7821 36.4883 55.8732 41.3972 55.8732 47.4527C55.8732 53.5082 60.7821 58.4171 66.8376 58.4171Z",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M202.898 170.357L200.176 164.486",
    stroke: "#0E090C",
    strokeWidth: 0.773196,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSessionOut);
export default __webpack_public_path__ + "static/media/SessionOut.e238faf2d4bd98a33908d5408c6dd7a9.svg";
export { ForwardRef as ReactComponent };